<div class="typing-indicator">
  <span></span>
  <span></span>
  <span></span>
</div>